<template>
  <Layout>
    <div class="contianer mv6">
      <div class="home-row">
        <div class="home-left rel">
          <!-- <el-carousel :interval="4000" type="card" height="280">
            <el-carousel-item v-for="(item, index) in banner" :key="index">
              <a :href="item.TargetUrl" class="medium full" target="_blank">
                <img :src="item.ImagePath" alt="" class="full img-cover" />
              </a>
            </el-carousel-item>
          </el-carousel> -->
          <img :src="(banner[0] || {}).ImagePath" class="img-cover full" />
          <div class="spec-name tc ph2 fs15 fwb line1">{{ specialtyName + specialtyEnglishName}}</div>
        </div>
        <!-- <SpecialtyBanner class="home-left mr4"></SpecialtyBanner> -->
        <new-prod-focus class="home-right"></new-prod-focus>
      </div>
      <!--相关病症-->
      <div class="home-row">
        <related-diseases class="home-left mr4" :params="{ CategoryType: 2, CategoryId: id }"></related-diseases>
        <div class="home-right">
          <ProdFocusText />
          <ProdFocus :ad="adMap[1]"></ProdFocus>
        </div>
      </div>
      <MeetingList class="home-left" :params="{ CategoryType: 2, CategoryId: id }"></MeetingList>
      <DiseaseList :params="{ CategoryType: 2, CategoryId: id, limit: 4 }"></DiseaseList>
      <NewsList :params="{ CategoryType: 2, CategoryId: id }"></NewsList>
      <!--培训课堂-->
      <training-class :params="{ CategoryType: 2, CategoryId: id, limit: 4 }" :lineNum="4"></training-class>
    </div>
  </Layout>
</template>

<script>
import Layout from '../../layout';
// import SpecialtyBanner from '@/components/SpecialtyBanner';
import NewProdFocus from '../../components/newProdFocus/Carousel';
import RelatedDiseases from '../../components/specialty/RelatedDiseases';
import ProdFocus from '../../components/ad/long-v';
import ProdFocusText from '../../components/common/prodFocus';
import TrainingClass from '../../components/TrainingClass';
import MeetingList from '@/components/meeting-list';
import DiseaseList from '@/components/disease-list';
import NewsList from '@/components/news-list';

import { mapGetters } from 'vuex';

export default {
  metaInfo() {
    return {
      title: this.specialtyName + ' ' + this.specialtyEnglishName + 'MIMS China',
      meta: [{                 // set meta
        name: 'keyWords',
        content: '药品信息、药物辨识图、药物相互作用、临床诊断、决策支持系统、用法用量、副作用、治疗指南'
      }, {
        name: 'description',
        content: '在中国、香港、台湾、马来西亚、新加坡、菲律宾、越南、泰国、印尼、印度和美国查询药物信息、药物相互作用、药物图片'
      }]
    }
  },
  components: {
    Layout,
    // SpecialtyBanner,
    // MyCarousel,
    NewProdFocus,
    RelatedDiseases,
    ProdFocus,
    MeetingList,
    DiseaseList,
    TrainingClass,
    ProdFocusText,
    NewsList,
  },
  data() {
    const { id } = this.$utils.query2Obj(location.search);

    return {
      id,
      banner: [],
    };
  },
  computed: {
    adMap() {
      return (this.$store.state.ad.adMap[5] || {})[this.id] || {};
    },
    ...mapGetters({
      departmentsMap: 'app/departmentsMap',
    }),
    specialtyName() {
      return (this.departmentsMap[this.id] || {}).Name;
    },
    specialtyEnglishName() {
      return (this.departmentsMap[this.id] || {}).EnglishName;
    },
  },
  created() {
    this.$store.dispatch('ad/getAds');
    this.$apis.app.getBanner({ limit: 8, AscriptionId: 5, ResRefId: this.id }).then(res => {
      this.banner = res.data;
    });
  },
};
</script>

<style lang="scss">
.spec-name {
  position: absolute;
  left: auto;
  top: auto;
  right: 0;
  bottom: 0;
  background: $theme-red;
  height: 38px;
  line-height: 38px;
  color: #fff;
  max-width: 90%;
}
</style>
